import type { FC } from 'react'
import styled from 'styled-components'

type Props = {
  items?: 4
}

export const EmptyAvatars: FC<Props> = ({ items = 6 }) => (
  <StyledEmptyWrapper>
    {new Array(items).fill({ item: '' })?.map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <StyledEmptyDot data-testid="empty-dot" key={index} />
    ))}
  </StyledEmptyWrapper>
)

const StyledEmptyDot = styled.div`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.color.neutral.color8};
  margin-right: 15px;
`

const StyledEmptyWrapper = styled.div`
  display: flex;
  margin-top: 10px;
`
